import { createActionCreator } from '../../utils/helpers';

import { makeChampion, OPEN_MAKE_CHAMPION_MODAL, CLOSE_MAKE_CHAMPION_MODAL } from './types';

export const requestMakeChampion = createActionCreator(
  makeChampion.request,
  'teamMemberId',
  'teamId',
);
export const requestMakeChampionSuccess = createActionCreator(makeChampion.success, 'response');
export const requestMakeChampionFailure = createActionCreator(makeChampion.failure, 'error');

export const openMakeChampionModal = createActionCreator(
  OPEN_MAKE_CHAMPION_MODAL,
  'teamMember',
  'team',
);
export const closeMakeChampionModal = createActionCreator(CLOSE_MAKE_CHAMPION_MODAL);
